import { ApiService } from './ApiService';
import { TokenRequiredStrategy } from '../strategies/TokenRequiredStrategy';
import { ApiEndpoints } from '@/constants/ApiEndpoints';

import log from 'loglevel';
import { InitData } from '@/interfaces/InitData';
import { INetwork } from '../../interfaces/INetwork';
import { Category } from '../../interfaces/Category';
import { User, createUser } from '../../interfaces/User';
import { OfferSortOptions } from '@/interfaces/Offers/OfferSortOptions';

class InitServiceClass extends ApiService {


  private INIT_ENDPOINT = ApiEndpoints.INIT;

  constructor() {
    super(TokenRequiredStrategy)
  }


  async fetchInitData(): Promise<InitData> {
    try {
      const response = await this.get(this.INIT_ENDPOINT);

      const user: User = createUser(response.user);
      const earnCategory: Category[] = response.earn_categories;
      const networks: INetwork[] = response.networks;
      const offerSortOptions: OfferSortOptions[] = response.configs.offers_sort_options;
      const user_metrics = response.user_metrics;

      return {
        user,
        earnCategory,
        networks,
        offerSortOptions,
        user_metrics
      };

    } catch (error) {
      log.error('Failed to fetch init data:', error);
      throw error;
    }
  }



}

// Create an instance of the class and export it
const InitService = new InitServiceClass();
export { InitService };
